import type { FarmerFormData } from '../types';

export const FARMER_FIELD_LABELS: Record<string, string> = {
	name: 'Nome',
	surName: 'Sobrenome',
	document: 'CPF/CNPJ',
	phoneNumber: 'Telefone',
	email: 'E-mail',
	status: 'Status',
};

export const DEFAULT_FARMER_FORM: FarmerFormData = {
	name: '',
	surName: '',
	phoneNumber: '',
	email: '',
	document: '',
	status: '',
};
